import React, { useContext, useEffect, useMemo, useState } from 'react';
import { fetchData } from '../service/data.service';

const ExperienceSleepContext = React.createContext();

export const useExperienceSleepContext = () => useContext(ExperienceSleepContext);

export function ExperienceSleepProvider({ children }) {
  const [recommendedExperiences, setRecommendedExperiences] = useState([]);
  const [recommendedHeading, setRecommendedHeading] = useState({});
  const [infoContent, setInfoContent] = useState({});
  const [suggestedQuestions, setSuggestedQuestions] = useState({});
  const [iframeData, setIframeData] = useState({});

  useEffect(() => {
    fetchData
      .get('https://run.mocky.io/v3/300e0009-0939-442a-9afa-e346c2870c2e')
      .then(setRecommendedExperiences);
    fetchData
      .get('https://run.mocky.io/v3/ddf670d8-e7aa-4224-a0a1-0012c54d8d0c')
      .then(setRecommendedHeading);
    fetchData
      .get('https://run.mocky.io/v3/f9265f84-2764-4686-85e3-7cd8998cfc94')
      .then(setSuggestedQuestions);
    fetchData
      .get('https://run.mocky.io/v3/eecec156-bc39-42e0-90a0-30f560e30c4f')
      .then(setInfoContent);
    fetchData
      .get('https://run.mocky.io/v3/4ceed670-b8a9-4741-b8ee-106b3d69e73a')
      .then(setIframeData);
  }, []);

  const value = useMemo(
    () => ({
      recommendedExperiences,
      recommendedHeading,
      infoContent,
      suggestedQuestions,
      iframeData,
    }),
    [recommendedExperiences, recommendedHeading, infoContent, suggestedQuestions, iframeData]
  );

  return (
    <ExperienceSleepContext.Provider value={value}>{children}</ExperienceSleepContext.Provider>
  );
}
